import React from 'react';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './Footer.scss';
import DownArrow from '../../assets/chevron-down.svg';
import Logo from '../../assets/CSLBehring_Logo.png';

function Footer() {
  const [footerClass, setFooterClass] = useState('fixed-footer');

  useEffect(() => {
    window.addEventListener('scroll', () => {
      const body = document.querySelector('.body-container');
      if (window.scrollY + window.innerHeight >= body.offsetTop + body.offsetHeight - 25) {
        setFooterClass('');
      } else {
        setFooterClass('fixed-footer');
      }
    });
  }, []);

  const scrollToFooter = () => {
    const footer = document.querySelector('.footer');
    setFooterClass('');
    setTimeout(() => {
      window.scrollTo({
        top: footer.offsetTop,
        behavior: 'smooth'
      });
    }, 100);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className={`footer ${footerClass}`}>
      <div className="isi-container">
        <div className="isi-top">
          <div className="isi-top-content">
            <h2>IMPORTANT SAFETY INFORMATION</h2>
            <img src={DownArrow} alt="down arrow" className="down-arrow" onClick={scrollToFooter} />
          </div>
        </div>
        <div className="isi-bottom">
          <h3>Warning and Precautions</h3>
          <h4>Infusion Reactions</h4>
          <p>
            Infusion reactions, including hypersensitivity reactions and anaphylaxis, may occur.
            Monitor during administration and for at least 3 hours after end of infusion. If
            symptoms occur, slow or interrupt administration. Re-start administration at a slower
            infusion once resolved.
          </p>
          <h4>Hepatotoxicity/Hepatocellular Carcinoma</h4>
          <p>
            Post-dose, monitor for elevated transaminase levels. Consider corticosteroid treatment
            should elevations occur. The integration of liver-targeting AAV vector DNA into the
            genome may carry the theoretical risk of hepatocellular carcinoma development. For
            patients with preexisting risk factors for hepatocellular carcinogenicity, perform
            regular (eg, annual) abdominal ultrasound and alpha-fetoprotein testing following
            administration.
          </p>
          <h4>Immune-mediated neutralization of the AAV5 vector capsid</h4>
          <p>
            Preexisting neutralizing anti-AAV antibodies may impede transgene expression at desired
            levels.
          </p>
          <h4>Monitoring Laboratory Tests</h4>
          <p>
            In addition to monitoring liver function, monitor for Factor IX activity and Factor IX
            inhibitors after administration.
          </p>
          <h3>Adverse Reactions</h3>
          <p>
            The most common adverse reactions (incidence ≥5%) were elevated ALT, headache, blood
            creatine kinase elevations, flu-like symptoms, infusion-related reactions, fatigue,
            nausea, malaise, and elevated AST.
          </p>
          <h3>Indication </h3>
          <p>
            HEMGENIX®, etranacogene dezaparvovec-drlb, is an adeno-associated virus vector-based
            gene therapy indicated for the treatment of adults with Hemophilia B (congenital Factor
            IX deficiency) who:
          </p>
          <ul className="bullets">
            <li>Currently use Factor IX prophylaxis therapy, or</li>
            <li>Have current or historical life-threatening hemorrhage, or</li>
            <li>Have repeated, serious spontaneous bleeding episodes.</li>
          </ul>
          <p>HEMGENIX is for single use intravenous infusion only.</p>
          <h3>
            Contraindications: <span className="common-text">None.</span>
          </h3>
          <div className="bold-text">
            Please see full{' '}
            <a
              className="purple-link"
              href="https://labeling.cslbehring.com/PI/US/Hemgenix/EN/Hemgenix-Prescribing-Information.pdf"
              target="_blank"
              rel="noreferrer"
            >
              prescribing information
            </a>{' '}
            for HEMGENIX.
          </div>
          <p>
            To report SUSPECTED ADVERSE REACTIONS, contact the CSL Behring Pharmacovigilance
            Department at <span style={{ whiteSpace: 'nowrap' }}>1-866-915-6958</span> or FDA at{' '}
            <span style={{ whiteSpace: 'nowrap' }}>1-800-FDA-1088</span> or{' '}
            <a
              className="common-text"
              href="https://www.fda.gov/safety/medwatch-fda-safety-information-and-adverse-event-reporting-program"
              target="_blank"
              rel="noreferrer"
            >
              www.fda.gov/medwatch
            </a>
            .
          </p>
        </div>
        <div className="copyright-section">
          <img src={Logo} alt="CSL Behring Logo" className="logo" />
          <div className="footer-links">
            <a href="https://www.hemgenix.com/hcp/privacy-policy" target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
            <a href="https://www.hemgenix.com/hcp/terms-of-use" target="_blank" rel="noreferrer">
              Terms of Use
            </a>
            <a href="https://www.cslbehring.com/our-company" target="_blank" rel="noreferrer">
              About CSL Behring
            </a>
            <Link to="/cookie-policy" onClick={scrollToTop}>
              Cookie Policy
            </Link>
          </div>
          <div>
            <p>HEMGENIX is manufactured by uniQure Inc. and distributed by CSL Behring LLC.</p>
            <p>HEMGENIX® is a registered trademark of CSL Behring LLC.</p>
          </div>
          <div>
            <p>
              <span style={{ fontWeight: '500' }}>©2023 CSL Behring LLC</span> 1020 First Avenue, PO
              Box 61501, King of Prussia, PA 19406-0901 USA
            </p>
            <p>
              <a href="https://www.CSLBehring.com" target="_blank" rel="noreferrer">
                www.CSLBehring.com
              </a>{' '}
              <a href="https://www.hemgenix.com/hcp" target="_blank" rel="noreferrer" s>
                www.HEMGENIX.com
              </a>{' '}
              <span style={{ fontWeight: '500' }}>USA-HGX-0424-APR23</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
